<template>
  <v-layout v-if="form" row wrap>
    <v-flex
      v-for="(block, blockIndex) in blocks"
      :key="blockIndex"
      xs12
      :class="{ ['sm' + (width == 0 ? (12 / blocks.length) : width)] : true }"
    >
      <v-layout
        v-for="(input, inputIndex) in block"
        v-if="input.show || typeof(input.show) == 'undefined'"
        :key="inputIndex"
        px-2
        :class="{'has-header': input.hasHeader, 'visibility-hidden': input.hidden}"
        class="form-group-custom row"
      >
        <v-flex xs12 :sm6="!input.hasHeader">
          <v-subheader v-text="input.text" />
        </v-flex>
        <v-flex xs12 :sm6="!input.hasHeader">
          <pos-checkbox
            v-if="input.type === 'checkbox'"
            :disabled="disabled"
            :label="input.label"
            :ref="input.fieldName"
            v-model="model[input.fieldName]"
          />

          <pos-select
            v-else-if="input.type === 'select'"
            v-model="model[input.fieldName]"
            v-validate="!disabled ? input.rules : ''"
            v-show="input.show !== false"
            :items="input.items"
            :name="input.fieldName"
            :label="input.placeholder"
            :valueField="input.valueField"
            :mixerGroup="input.mixerGroup"
            :disabled="disabled"
            :multiple="input.multiple"
            :emptyText="input.emptyText"
            :error="errors.collect(input.fieldName)"
          />

          <pos-select
            v-else-if="input.type === 'selectColor'"
            v-model="model[input.fieldName]"
            v-validate="!disabled ? input.rules : ''"
            :items="input.items"
            :name="input.fieldName"
            :disabled="disabled"
            :color="true"
            :error="errors.collect(input.fieldName)"
          />

          <pos-date-picker
            v-else-if="input.type === 'date-picker'"
            v-model="model[input.fieldName]"
            v-validate="!disabled ? input.rules : ''"
            :data-vv-name="input.fieldName"
            :error-messages="errors.has(input.fieldName) ? errors.collect(input.fieldName)[0] : ''"
            :disabled="disabled"
            :ref="input.fieldName"
            :min="getDateFromRef(input.minRef)"
            :max="getDateFromRef(input.maxRef)"
          />

          <pos-time-picker
            v-else-if="input.type === 'time-picker'"
            v-model="model[input.fieldName]"
            v-validate="!disabled ? input.rules : ''"
            :data-vv-name="input.fieldName"
            :error-messages="errors.has(input.fieldName) ? errors.collect(input.fieldName)[0] : ''"
            :disabled="disabled"
            :readonly="input.readonly"
          />

          <pos-dob-picker
            v-else-if="input.type === 'dob-picker'"
            v-model="model[input.fieldName]"
            v-validate="!disabled ? input.rules : ''"
            :data-vv-name="input.fieldName"
            :error-messages="errors.has(input.fieldName) ? errors.collect(input.fieldName)[0] : ''"
            :disabled="disabled"
          />

          <v-layout v-else-if="input.type === 'multi-checkbox'" class="row wrap">
            <v-flex v-for="(child, childIndex) in input.childs" :key="childIndex">
              <pos-checkbox
                v-if="child.type === 'checkbox'"
                :disabled="disabled"
                :ref="child.fieldName"
                :label="child.text"
                v-model="model[child.fieldName]"
              />
            </v-flex>
          </v-layout>

          <pos-radio-group
            v-else-if="input.type === 'radio-group'"
            v-model="model[input.fieldName]"
            :radios="input.radios"
            :disabled="disabled"
            @focusRadio="input.unchecked ? posRadioGroupChange($event, input.fieldName) : ''"
          />

          <v-layout v-else-if="input.type === 'input-duo'" class="row">
            <v-flex xs12 sm6 v-for="(child, childIndex) in input.childs" :key="childIndex">
              <pos-select
                v-if="child.type === 'select'"
                v-model="model[child.fieldName]"
                v-validate="!disabled ? child.rules : ''"
                :items="child.items"
                :name="child.fieldName"
                :error="errors.collect(child.fieldName)"
                :disabled="disabled"
              />
              <v-text-field
                v-else
                solo
                v-model="model[child.fieldName]"
                v-validate="!disabled ? child.rules : ''"
                :suffix="child.suffix"
                :prefix="child.prefix"
                :data-vv-name="child.fieldName"
                :label="child.label"
                :error-messages="errors.has(child.fieldName) ? errors.collect(child.fieldName)[0] : ''"
                :disabled="disabled"
              />

            </v-flex>
          </v-layout>
          <pos-combobox
            v-else-if="input.type === 'combobox'"
            v-model="model[input.fieldName]"
            v-validate="!disabled ? input.rules : ''"
            :name="input.fieldName"
            :valueField="input.valueField"
            :mixerGroup="input.mixerGroup"
            :disabled="disabled"
            :emptyText="input.emptyText"
            :error="errors.collect(input.fieldName)"
          />

          <pos-select-list
            v-else-if="input.type === 'selectList'"
            @input="model[input.fieldName] = $event"
            v-validate="!disabled ? input.rules : ''"
            :name="input.fieldName"
            v-model="model[input.fieldName]"
            :error="errors.collect(input.fieldName)"
            :radio="input.radio ? input.radio : false"
            :items="input.items"
          />
          <pos-crop-image-upload
            v-else-if="input.type === 'picture'"
            v-model="model[input.fieldName]"
            :error="errors.collect(input.fieldName)"
          />
          <pos-logo-upload
            v-else-if="input.type === 'logo'"
            v-model="model[input.fieldName]"
            :locationId="input.type === 'logo' ? model.id : 0"
            :error="errors.collect(input.fieldName)"
          />
          <v-text-field
            v-else
            solo
            :ref="input.fieldName"
            v-model="model[input.fieldName]"
            v-validate="!disabled ? input.rules : ''"
            :suffix="input.suffix"
            :prefix="input.prefix"
            :data-vv-name="input.fieldName"
            :error-messages="errors.has(input.fieldName) ? errors.collect(input.fieldName)[0] : ''"
            :disabled="disabled || input.disabled"
            :readonly ="input.readonly"/>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import Vue from "vue";

export default {
  name: "PosForm",
  props: {
    form: { type: Array, default: () => [] },
    model: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
    width: { type: Number, default: 0 }
  },
  data: function() {
    return {
      repeat: null
    };
  },
  computed: {
    blocks() {
      if (this.form.length == 0) return [];
      if (this.form[0] && Array.isArray(this.form[0])) return this.form;
      return [this.form];
    }
  },
  methods: {
    posRadioGroupChange($event, value) {
      if ($event == this.repeat) {
        this.model[value] = null;
      }
      this.repeat = this.model[value];
    },
    async validate() {
      return await this.$validator.validate();
    },
    getDateFromRef(ref) {
      const datePicker = this.$refs[ref];
      if (!datePicker) {
        return "";
      }

      const { date } = datePicker[0];
      if (!date) {
        return "";
      }

      return typeof date === "string" ? date : date.toISOString();
    }
  },
  watch: {
    model: {
      handler(value) {
        this.$emit("onModelChange", value);
      },
      deep: true
    }
  }
};
</script>
<style lang="css">
.visibility-hidden {
  visibility: hidden;
}
</style>
